import { BaseEnum } from "./baseEnum";

const promotionRequestTypes: Array<PromotionRequestType> = [];

export class PromotionRequestType extends BaseEnum {
  static MERIT = new PromotionRequestType(1, "Merit", "Mérito");
  static SENIORITY = new PromotionRequestType(2, "Seniority", "Senioridade");

  constructor(public id: number, public value: string, public label: string) {
    super(id, value, label);

    promotionRequestTypes.push(this);
  }

  public static buildListEnum(): Array<BaseEnum> {
    return promotionRequestTypes;
  }

  public static getByAny(value: string | null | undefined): PromotionRequestType | undefined {
    const normalizedValue = (value || "").trim().toUpperCase();

    return promotionRequestTypes.find(item =>
      item.value.toUpperCase() === normalizedValue || item.label.toUpperCase() === normalizedValue
    );
  }
}
